// extracted by mini-css-extract-plugin
export var fileUpload = "_e6-1";
export var modalButton = "_e6-0";